import React, { useMemo } from "react";
// import { StdButton } from "../StdButton";
import { Config } from "../../Config";
import { EMPTY_ARRAY, fetchProviderByGeometry, fetchProviderByKeyword, WaterProvider } from "../misc";

import { AsyncSearchResult, GeoData, GeoDataFromApi } from "./types";
import { AsyncSelect, AsyncSelectComponentType } from "./AsyncSelect";

import { MenuListProps } from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import _ from "lodash";

import styles from "./GeoEncoder.module.scss";

// QLD coordinates
const AU_SHORT_CODE = "AU-QLD";
const bbox = [137.994324998, -29.1778977, 153.552171248, -9.14217597699997];
const token = "pk.eyJ1Ijoic21hbGxtdWx0aXBsZXMiLCJhIjoiRk4xSUp6OCJ9.GilBdBaV0oKMZgBwBqRMWA";
const baseUrl = `${Config.geoEncodingEndpoint}/{text}.json?country=au&limit=50&bbox=${bbox}&access_token=${token}`;
const getUrl = (text: string) => {
    return baseUrl.replace("{text}", text.replace(/\s/g, "+"));
};

type GeoEncoderRecord = {
    type: "byName" | "byAddress";
    name: string;
    keyword: string;
    data:
        | GeoData
        | {
              name: string;
              provider: WaterProvider;
          };
};

const getValues = async (text: string): Promise<GeoEncoderRecord[]> =>
    // Array<GeoData>
    {
        if (!text || text.length < 2) {
            return [];
        }

        const providersByName = await fetchProviderByKeyword(text).then(data => {
            return (
                data
                    ?.filter(d => d != null)
                    ?.map(d => {
                        return {
                            name: d?.name,
                            provider: d
                        };
                    }) ?? (EMPTY_ARRAY as Array<{ name: string; provider: WaterProvider }>)
            );
        });

        const providersByAddress = await fetch(getUrl(text))
            .then(res => res.json())
            .then(data => {
                return Promise.all<GeoData>(
                    data.features
                        .filter((d: any) => {
                            return d.context.find(d => d.short_code === AU_SHORT_CODE);
                            // && this.validateLocation(d);
                        })
                        .map(async ({ center, geometry, place_name }: GeoDataFromApi) => {
                            const lon = center[0];
                            const lat = center[1];
                            try {
                                const docs = await fetchProviderByGeometry(lon, lat);
                                if (docs.length !== 1) return undefined;

                                // remove state, post code and nation

                                const name = place_name.replace(
                                    /(,)?( Queensland)?( ((\d){4}))?(,)?( Australia)?$/i,
                                    ""
                                );

                                return {
                                    center,
                                    geometry,
                                    name,
                                    provider: docs[0]
                                };
                            } catch (err) {
                                console.log(err);
                                return undefined;
                            }
                        })
                ).then(docs => {
                    if (!docs?.length) return [];

                    return docs.filter(doc => doc != null);
                });
            });

        const retByNames: GeoEncoderRecord[] = providersByName.map(d => {
            return {
                type: "byName",
                name: d.name,
                data: d,
                keyword: text
            };
        });

        const retByAddress: GeoEncoderRecord[] = providersByAddress.map(d => {
            return {
                type: "byAddress",
                name: d.name,
                data: d,
                keyword: text
            };
        });

        return [...retByNames, ...retByAddress];
    };

const MenuList: React.FC<MenuListProps> = props => {
    const { options, selectOption, maxHeight } = props;

    const providersByName: GeoEncoderRecord[] = useMemo(() => {
        const _options = options as GeoEncoderRecord[];
        if (!_options?.length) return EMPTY_ARRAY as GeoEncoderRecord[];

        return _options.filter(option => {
            return option?.type === "byName";
        });
    }, [options]);

    const providersByAddress: GeoEncoderRecord[] = useMemo(() => {
        const _options = options as GeoEncoderRecord[];
        if (!_options?.length) return EMPTY_ARRAY as GeoEncoderRecord[];

        return _options.filter(option => {
            return option?.type === "byAddress";
        });
    }, [options]);

    return (
        <div
            className={styles.menu}
            style={{
                maxHeight
            }}
        >
            {!(options?.length > 0) && <div className={styles.nooptions}>No options</div>}

            {providersByName?.length > 0 && (
                <div className={styles.section}>
                    <div>Providers by name:</div>

                    {providersByName?.map((option, index) => {
                        return (
                            <div
                                className={styles.option}
                                key={index}
                                onClick={() => {
                                    selectOption(option);
                                }}
                            >
                                <span className={`${styles.optionContainer} ${styles.highlight}`}>{option?.name}</span>
                                <div className={styles.optionContainerArrow}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            {providersByAddress?.length > 0 && (
                <div className={styles.section}>
                    <div>Providers by address:</div>

                    {providersByAddress?.map((option, index) => {
                        return (
                            <div
                                className={styles.option}
                                key={index}
                                onClick={() => {
                                    selectOption(option);
                                }}
                            >
                                <span className={styles.optionContainer}>{option.name}</span>
                                <div className={styles.optionContainerExtraContent}>
                                    {(option?.data as GeoData)?.provider?.name}
                                </div>
                                <div className={styles.optionContainerArrow}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            {/* <div className={styles.section}>
                <div>Providers by name:</div>
                <div className={styles.option}>
                    <span className={styles.optionContainer}>Name</span>
                    <div className={styles.optionContainerArrow}>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </div>
                </div>
            </div>

            <div className={styles.section}>
                <div>Providers by address:</div>
                <div className={styles.option}>
                    <span className={styles.optionContainer}>Address</span>
                    <div className={styles.optionContainerExtraContent}>ProviderName</div>
                    <div className={styles.optionContainerArrow}>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export interface GeoEncoderProps {
    onChange?: (item: GeoEncoderRecord) => void;
    value?: GeoEncoderRecord;
}

export const GeoEncoder: React.FC<GeoEncoderProps> = ({ onChange, value }) => {
    const components: AsyncSelectComponentType = useMemo(() => {
        return {
            MenuList
            // Option: DropdownOption
        };
    }, []);

    const _getValues = useMemo(() => {
        return _.debounce(getValues, 200, { maxWait: 1000 });
        // return getValues;
    }, []);
    return (
        <>
            {/* <Menu
                // options: undefined[]; selectOption: () => void; setValue: () => void; clearValue: () => void;
                options={[
                    {
                        type: "byName",
                        name: "www",
                        provider: {
                            name: "www",
                            adminId: "www"
                        }
                    }
                ]}
                selectOption={() => {}}
                setValue={() => {}}
                clearValue={() => {}}
                innerRef={function (instance: HTMLDivElement): void {
                    throw new Error("Function not implemented.");
                }}
                innerProps={undefined}
                isLoading={false}
                placement={"bottom"}
                children={""}
                cx={function (state: ClassNamesState, className?: string): string {
                    throw new Error("Function not implemented.");
                }}
                getStyles={null}
                getValue={null}
                hasValue={false}
                isMulti={false}
                isRtl={false}
                selectProps={undefined}
                theme={undefined}
                minMenuHeight={0}
                maxMenuHeight={0}
                menuPlacement={"bottom"}
                menuPosition={"fixed"}
                menuShouldScrollIntoView={false}
            /> */}
            <AsyncSelect
                onChange={onChange}
                value={value}
                placeholder="Search for a provider (enter name, address or location)"
                getValues={_getValues as unknown as (text: string) => Promise<AsyncSearchResult[]>}
                components={components}
            />
        </>
    );
};
